import { Grid } from '@mantine/core';
import { formatDate } from '../../../helpers/date-convert';
import { RetrievedIncorporator } from '../../../type/onboard-merchant-request.types';
import { TextInfo } from '../../safe-text/safe-text.component';

interface MerchantInfoIncorporatorProps {
  incorporator: RetrievedIncorporator;
}
function MerchantInfoIncorporator(props: MerchantInfoIncorporatorProps) {
  const { incorporator } = props;
  const labels = {
    incorporatorFirstName: 'First name',
    incorporatorMiddleName: 'Middle name',
    incorporatorLastName: 'Last name',
    incorporatorEmailAddress: 'Email address',
    incorporatorContactNumber: 'Contact number',
    incorporatorBirthDate: 'Birthdate',
    incorporatorBldgNameNo: 'Building name and number',
    incorporatorResidentialAddress: 'Residential address',
    incorporatorBarangay: 'Barangay',
    incorporatorCity: 'City',
    incorporatorProvince: 'Province',
    incorporatorPostalCode: 'Postal code',
  };
  return (
    <>
      <Grid>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorFirstName}
            value={incorporator.firstName}
            dataCy='firstName'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorMiddleName}
            value={incorporator.middleName}
            dataCy='middleName'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorLastName}
            value={incorporator.lastName}
            dataCy='lastName'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorEmailAddress}
            value={incorporator.emailAddress}
            dataCy='emailAddress'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorContactNumber}
            value={'+63 ' + incorporator.contactNumber}
            dataCy='contactNumber'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorBirthDate}
            value={
              incorporator.dateOfBirth
                ? formatDate(incorporator.dateOfBirth.toString())
                : ''
            }
            dataCy='dateOfBirth'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorBldgNameNo}
            value={
              !incorporator.address.buildingNameAndNumber
                ? '.'
                : incorporator.address.buildingNameAndNumber
            }
            dataCy='buildingNameAndNumber'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorResidentialAddress}
            value={incorporator.address.line1}
            dataCy='line1'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorBarangay}
            value={incorporator.address.barangay}
            dataCy='barangay'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorCity}
            value={incorporator.address.city}
            dataCy='city'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorProvince}
            value={incorporator.address.state}
            dataCy='state'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.incorporatorPostalCode}
            value={incorporator.address.postalCode}
            dataCy='postalCode'
          />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default MerchantInfoIncorporator;
